<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('app.save_search')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('app.save_search')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <span id="create-search-dialog-nombre-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('configurations.name')}}</span>
              <el-form-item prop="nombre">
                <el-input
                  aria-labelledby="create-search-dialog-nombre-label"
                  type="text"
                  class="w-full"
                  v-model="form.nombre"
                  maxlength='50'
                >
                  <template v-if="form.nombre" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo de nombre de búsqueda"
                      @clear="form.nombre = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
          </div>
          
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button 
        class="w-full"
        @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './../base/BaseDialogButton.vue'
import { guardarBusqueda } from '@/services/searches/guardarBusqueda'

export default
{
  name: 'create-search-dialog',
  components: {
    BaseDialogButton
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    tags: {
      type: [Array]
    },
    idVista: {
      type: Number,
      default: -1
    },
    numberSearches: {
      type: Number,
      default: 0
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      maxSearches: 10,
      form: {
        nombre: ''
      },
      rules: {
        nombre: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ]
      }
    }
  },
  mounted: async function () {
  
  },
  computed: {
    isLimitExceed: function () {
      return this.numberSearches >= this.maxSearches
    }
  },
  methods: {
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.nombre = ''
    },
    apply: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      if (this.isLimitExceed) {
        this.doFeedback('Se ha superado el número máximo de búsquedas guardadas (' + this.maxSearches + ')', 'warning')
        this.$store.commit('setIsLoading', false)
        return
      }
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            IdVista: this.idVista,
            Nombre: this.form.nombre,
            Filtros: [],
            Version: this.$store.getters['app/version']
          }
          this.tags.forEach(element => {
            // Filtros multiples
            if (Array.isArray(element[2])) {
              element[2].forEach(elValor => {
                payload.Filtros.push({ Clave: element[0], Valor: elValor })
              })
            } else {
              // Filtros object, multiples, objetos
              if (element[0] === 'metadato1' || element[0] === 'metadato2' || element[0] === 'metadato3' || element[0] === 'metadato4' || element[0] === 'metadato5') {
                payload.Filtros.push({ Clave: element[0], Valor: JSON.stringify(element[2]) })
              } else {
                // Filtros normales
                payload.Filtros.push({ Clave: element[0], Valor: element[2] })
              }
            }
          })
          const response = await guardarBusqueda(payload)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.doFeedback('Búsqueda creada correctamente', 'success')
            this.isOpen = !this.isOpen
            // this.$emit('toggleDialog')
            this.$emit('applyDialog')
            this.form.nombre = ''
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
  }
}
</script>

<style lang="scss" scoped></style>
